export default {
    viewAttendance: 'View Attendance',
    profile: 'Profile',
    employeeId: 'Employee ID',
    employeeFullname: 'Name Surname',
    email: 'Email address',
    position: 'Position',
    bureau: 'ฺBureau',
    attendanceDetail: 'Attendance Detail',
    date: 'Date',
    time: 'Time',
    method: 'Method',
    temperature: 'Temperature',
    location: 'Location',
    attachment: 'Attachment',
    thereIsNoPunchLog: 'There is no time attendance'
}
